import Styles from './styles.module.scss';

interface Props {
	onCounter: number;
	offCounter: number;
}

export const DeviceStatus = ({ onCounter, offCounter }: Props) => {
	return (
		<div className={Styles.deviceStatusContainer}>
			<div className={Styles.item}>
				<div className={`${Styles.indicator} ${Styles.on}`} />
				<span>{onCounter}</span>
			</div>
			<div className={Styles.item}>
				<div className={`${Styles.indicator} ${Styles.off}`} />
				<span>{offCounter}</span>
			</div>
		</div>
	);
};
